// Phase 9.4b + 9.6.2 — Bar Stock tab.
//
// Bar items are location-locked to Kasol 2 (`gostops-kasol-2-0`) but
// the Bar Stock tab now uses the same property-per-section layout as
// the Merchandise tab (`LocationSegmentedListing`). Ops asked for a
// clear per-property list with sortable columns + a status color
// scheme; the shared component delivers that.

import LocationSegmentedListing from "./LocationSegmentedListing";

export default function FnbPoBarStock() {
  return (
    <div className="max-w-7xl mx-auto py-6 px-4">
      <LocationSegmentedListing
        title="Bar Stock"
        itemScope="bar"
        helperText="Alcohol + juice + mixers. Bar Stock is currently stocked only at Kasol 2 — that outlet appears below. Manual applicability toggles let you widen the bar scope to another outlet without changing sub-category classification."
        emptyText="No bar items configured. Check the Master Data page for the 7 curated sub-categories."
      />
    </div>
  );
}
